import Heading from "components/Heading/Heading";
import { FC } from "react";
import useNcId from "application/hooks/useNcId";

export interface SectionValuesProps {
  className?: string;
  uniqueClassName: string;
}
const SectionValues: FC<SectionValuesProps> = ({
  className = "",
  uniqueClassName = "",
}) => {
  const UNIQUE_CLASS = `SectionValues_glide_${uniqueClassName}` + useNcId();

  return (
    <div
      className={`nc-SectionValues relative ${className} `}
      data-nc-id="SectionValues"
    >
      <Heading className="m-0" desc="Crediamo fortemente in una particolare attenzione ai nostri clienti, ai membri delle nostre TribYou attuali e future. Facciamo scoprire luoghi che meritano di essere vissuti. Facilitiamo incontri fra persone che possano arricchire i momenti vissuti nelle nostre destinazioni. Crediamo nel facilitare la vita delle persone individuando luoghi di aggregazione e per lavorare." isCenter>
        I nostri valori
      </Heading>
    </div>
  );
};

export default SectionValues;
